import { Linker } from "./Linker";
export async function loadLinksInteraction(engine, refresh = true) {
    await engine.addInteractor("particlesLinks", (container) => new Linker(container), refresh);
}
